import { reportAPI, trackingAPI } from "../api/api";
import { Import } from "../store/types/import";
import { handleServiceError } from "./handleServiceError";

const importService: any = {
  importFile: async (
    importObject: Import
  ) => {
    try {
      return await trackingAPI.post(`/v1/macro/batch`, importObject.file);
    } catch (error) {
      handleServiceError(error);
    }
  },
};

export default importService;
